// src/components/NotFound.js
import React from "react";

const NotFound = () => {
  return (
    <div className="container mt-5 text-center">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <h1 className="display-1">404</h1>
          <h3 className="mb-3">Page Not Found</h3>
          <p>Sorry, the page you're looking for doesn't exist.</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
